<template>
  <div class="home">
    <el-card style="width: 400px; margin: 100px auto; text-align: center;">
      <div slot="header">
        <span>请选择入口</span>
      </div>
      <el-button type="primary" @click="$router.push('/admin')">物业后台</el-button>
      <el-button type="success" @click="$router.push('/shop')">店铺管理</el-button>
      <el-button type="warning" @click="$router.push('/user')">用户前台</el-button>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
